<template>
  <div>
    <div :class="['input-group',{ 'icon-valid': valid }, { 'icon-error': error }]" >
      <input
        id="input-cidades"
        name="cidade"
        class="base-input"
        type="text"
        ref="input"
        autocomplete="off"
        :value="searchCity"
        :placeholder="placeholder"
        @focus="focusInput"
        @blur="hideDropdown($event)"
        @input="e => searchCity = e.target.value"
        >
    </div>
    <ul
    v-if="showDropdown"
    class="custom-dropdown">
      <li
        v-for="(cidade, index) in cidadesFiltradas"
        :key="index"
        @click="() => selectInput(cidade)">{{ cidade.nome }} - {{ cidade.uf.id }}</li>
    </ul>
  </div>
</template>
<script>
import cidadesBrasileiras from '@/assets/json/cidadesBrasileiras.json';
import { CIDADES_ABREV } from '@/assets/js/constantes/cidadesAbreviacoes'

export default {
  data() {
    return {
      searchCity: '',
      dropdownShown: false,
      wasFocused: false,
      valid: false,
      error: false,
      selectDrop: false,
      errorMessageCity: 'Informe a cidade',
    }
  },
  props: {
    placeholder: {
      type: String,
      default: 'Ex: São Paulo - SP'
    },
    selectCidade: {
      type: Function,
      required: true,
    },
    focused: {
      type: Boolean,
      required: false,
      default: false,
    },
    normalizeSearch: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.focused) {
      this.focusNativeInput();
    }
  },
  methods: {
    focusInput() {
      this.dropdownShown = true
      this.wasFocused = true
    },
    existsCity() {
      return this.cidadesBrasileiras.some(cidade => {
        return this.tryNormalize(cidade.nome) === this.tryNormalize(this.searchCity);
      })
    },
    tryNormalize(text) {
      if (this.normalizeSearch) {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      }
      return text;
    },
    hideDropdown(event) {
      setTimeout(() => {
        const cidade = this.cidadesFiltradas[0]
        this.$emit('blur', { event, value: cidade })

        if(!cidade && this.searchCity.length < 2) {
          this.searchCity = ''
        }

        this.dropdownShown = false

        if(!this.selectDrop) {
        const cityNormalize = this.normalizeText(this.searchCity)
        this.enviaGA(cityNormalize)
      }
      }, 300)

    },
    enviaGA(cidade) {
      const pathLocation = window.location.pathname.replaceAll("/", "")
        dataLayer.push({
            event: 'customEvent',
            eventCategory: `blog: ${pathLocation}`,
            eventAction: 'preencheu:calculadora-custo-cnpj',
            eventLabel: `cidade|${cidade}`
          })
    },
    normalizeText(text) {
      return (text || '').normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replaceAll(' ','-').toLowerCase();
    },
    selectInput(cidade) {
      this.selectDrop = true
      this.searchCity = cidade.nome

      this.$emit('citySelectedEvent', true)
      this.selectCidade(cidade.nome)

      const cityNormalize = this.normalizeText(this.searchCity)
      this.enviaGA(cityNormalize)
    },
  },
  computed: {
    cidadesBrasileiras() {
      return cidadesBrasileiras;
    },
    showDropdown() {
      return this.searchCity.length >= 2 && this.dropdownShown
    },
    cidadesFiltradas() {
      return this.searchCity !== '' ? this.cidadesBrasileiras.filter(cidade => {
        const simpleTerm = this.searchCity.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()

        return CIDADES_ABREV[simpleTerm]
          ? cidade.nomeNormalizado === CIDADES_ABREV[simpleTerm].normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
          : cidade.nomeNormalizado.search(simpleTerm) >= 0
      }) : []
    }
  },
  watch: {
    searchCity() {
      this.$emit('input', this.searchCity)
      this.selectCidade(this.searchCity);

      if(this.searchCity === '' && this.wasFocused) {
        this.error = true
        this.valid = false
        this.errorMessageCity = 'Informe a cidade'
        this.$emit('errorEvent', true)
      }
      else if(this.wasFocused && this.existsCity()) {
        this.valid = true
        this.$emit('validInput', this.valid)
        this.error = false
      }
      else {
        this.valid = false
        this.error = false
        this.errorMessageCity = 'Cidade inválida'
      }
      this.$emit('validInput', this.valid);
    },
    onClear() {
      if (this.onClear) {
        this.searchCity = '';
        this.wasFocused = false;
      }
    },
    focused(value) {
      if (value) {
        this.focusNativeInput();
      }
    },
  },

}
</script>
<style lang="scss" src="./style.scss" scoped></style>
